(function () {
  // Drives the FAQ accordion + sidebar tracking on /pages/faqs.
  // We own the click → aria-expanded toggle (CSS handles the visual collapse).
  function init() {
    if (!document.body.classList.contains('page-faqs')) return;

    // Wire up accordion: clicking a question toggles its parent item.
    var items = document.querySelectorAll('[data-section-type="faq"] .Faq__Item');
    items.forEach(function (item) {
      var btn = item.querySelector('.Faq__Question');
      var answer = item.querySelector('.Faq__AnswerWrapper');
      if (!btn || !answer) return;
      // Defensive: clear any inline max-height/height the legacy theme might leave.
      answer.style.maxHeight = '';
      answer.style.height = '';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-expanded', 'false');
      var answerId = 'faq-answer-' + Math.random().toString(36).slice(2, 9);
      answer.id = answerId;
      btn.setAttribute('aria-controls', answerId);
      answer.setAttribute('role', 'region');
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          var open = item.getAttribute('aria-expanded') === 'true';
          var nextState = open ? 'false' : 'true';
          item.setAttribute('aria-expanded', nextState);
          btn.setAttribute('aria-expanded', nextState);
          answer.setAttribute('aria-hidden', open ? 'true' : 'false');
          // Clear any inline override the legacy handler may attempt to apply.
          answer.style.maxHeight = '';
          answer.style.height = '';
          // Bypass the CSS-cascade suppression that affects this page by
          // setting expanded-state visuals via inline !important on each toggle.
          if (open) {
            item.style.removeProperty('outline');
            item.style.removeProperty('outline-offset');
            btn.style.removeProperty('color');
          } else {
            item.style.setProperty('outline', '2px solid #4a6b85', 'important');
            item.style.setProperty('outline-offset', '-2px', 'important');
          }
        },
        true // capture phase — fire before the legacy listener
      );
    });

    var separators = document.querySelectorAll('[data-section-type="faq"] .Faq__Section');
    var summaryItems = document.querySelectorAll('.FaqSummary__Item');
    var summaryLinks = document.querySelectorAll('.FaqSummary__Link');
    if (!separators.length) return;

    var SCROLL_OFFSET = 100;

    function topOfDoc(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function update() {
      if (!summaryItems.length || summaryItems.length !== separators.length) return;
      var threshold = window.scrollY + SCROLL_OFFSET + 20;
      var activeIdx = 0;
      for (var i = 0; i < separators.length; i += 1) {
        var anchor = separators[i].querySelector('.Anchor') || separators[i];
        if (topOfDoc(anchor) <= threshold) activeIdx = i;
      }
      summaryItems.forEach(function (li, idx) {
        if (idx === activeIdx) {
          li.classList.add('is-active');
        } else {
          li.classList.remove('is-active');
        }
      });
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    summaryLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', href);
      });
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
